export enum CartActionTypes {
  // fetch cart
  FETCH = "FETCH_SHOPPING_CART",
  FETCH_START = "FETCH_SHOPPING_CART_START",
  FETCH_SUCCESS = "FETCH_SHOPPING_CART_SUCCESS",
  FETCH_FAIL = "FETCH_SHOPPING_CART_FAIL",
  // check cart sync
  CHECK_SYNC = "CHECK_SHOPPING_CART_SYNC",
  CHECK_SYNC_START = "CHECK_SHOPPING_CART_SYNC_START",
  CHECK_SYNC_SUCCESS = "CHECK_SHOPPING_CART_SYNC_SUCCESS",
  CHECK_SYNC_FAIL = "CHECK_SHOPPING_CART_SYNC_FAIL",
  CHECK_SYNC_SKIP = "CHECK_SHOPPING_CART_SYNC_SKIP",
  // update operation
  UPDATE = "UPDATE_SHOPPING_CART",
  UPDATE_START = "UPDATE_SHOPPING_CART_START",
  UPDATE_SUCCESS = "UPDATE_SHOPPING_CART_SUCCESS",
  UPDATE_FAIL = "UPDATE_SHOPPING_CART_FAIL",
  // add items operation
  ADD = "ADD_TO_SHOPPING_CART",
  // clear cart and then add items, can be used to overwrite the cart
  REMOVE_ALL_THEN_ADD = "REMOVE_ALL_POSITIONS_THEN_ADD_TO_SHOPPING_CART",
  ADD_START = "ADD_TO_SHOPPING_CART_START",
  ADD_SUCCESS = "ADD_TO_SHOPPING_CART_SUCCESS",
  ADD_FAIL = "ADD_TO_SHOPPING_CART_FAIL",
  // OTHER
  CHANGE_QTY = "CHANGE_SHOPPING_CART_POSITION_QTY",
  CHANGE_OPEN_QTY = "CHANGE_OPEN_SHOPPING_CART_QTY",
  REMOVE_POS = "REMOVE_SHOPPING_CART_POSITION",
  TOGGLE_POS = "TOGGLE_SHOPPING_CART_POSITION",
  TOGGLE_ALL_POS = "TOGGLE_ALL_SHOPPING_CART_POSITION",

  REMOVE_ALL_POSITIONS = "REMOVE_ALL_SHOPPING_CART_POSITIONS",

  UPDATE_CUSTOMER_MATNR = "UPDATE_SHOPPING_CART_CUSTOMER_MATNR",
  UPDATE_SEQUENCE_NUMBER = "UPDATE_SHOPPING_CART_SEQUENCE_NUMBER",
  UPDATE_ALL_SEQUENCE_NUMBERS = "UPDATE_SHOPPING_CART_ALL_SEQUENCE_NUMBERS",
  UPDATE_POS_COMMENT = "UPDATE_SHOPPING_CART_POS_COMMENT",
  UPDATE_EQUIPMENT_NUMBER = "UPDATE_EQUIPMENT_NUMBER",
  UPDATE_ROLL_NUMBER = "UPDATE_ROLL_NUMBER",
  MOVE_TO_ON_REQUEST_POSITIONS = "MOVE_TO_ON_REQUEST_POSITIONS",
  SPLIT_CART_POSITION = "SPLIT_CART_POSITION"
}

export enum CartPositionCollection {
  Order = "positions",
  Request = "onRequestPositions"
}
